export const UPC_COLUMN_FIELD = {
    key: "_upcs",
    display_name: "UPC",
};
export const SIZE_COLUMN_FIELD = {
    key: "_nu_sizes_manufactured",
    display_name: "Size",
};

export const SELECTED_SIZE_COLUMN_FIELD = {
    key: "selected_sizes",
    display_name: "Size",
};

export const MAX_ATTRIBUTE_NAME_LENGTH = 40;
